export const productosPesajeDinamico = [
      {
        id: 402,
        categoria: 'pesaje-dinamico',
        nombre: 'ESTANQUE',
        descripcion: 'Servibalanzas realiza la instalación y puesta en marcha de sistemas de pesaje para estanques, adaptados a distintos tipos de industrias como alimentos y bebidas, químicos, minería, combustibles y agricultura.',
        descripcion2: 'Nuestras soluciones permiten medir con precisión el contenido de los estanques en tiempo real, facilitando el control de inventarios, la dosificación de productos y la gestión de procesos productivos. ',
        imagen: '/imagenes/productos/PesajeDinamico/estanque-planta-industrial.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              'Alta precisión de pesaje gracias al uso de celdas de carga de última generación y sistema anticaída  ',
              'Compatibilidad con distintos tipos de estanques, ya sean metálicos, plásticos o de fibra, y de diferentes capacidades.  ',
              'Integración con sistemas automatizados de llenado, que controlan el flujo de entrada de líquidos o materiales a granel, asegurando el volumen exacto requerido.  ',
              'Instalación segura y adaptable, diseñada para entornos industriales exigentes y condiciones ambientales adversas.  ',
              'Mantenimiento y soporte técnico especializado, garantizando el funcionamiento continuo y la vida útil prolongada del sistema  ',
            ]
          }
        ],
        opciones: [
          {
            id: 'estanque',
            nombre: 'ESTANQUE',

          },
        ],
        imagenes: [
          '/imagenes/productos/PesajeDinamico/estanque-planta-industrial.webp',
          '/imagenes/productos/PesajeDinamico/estanque-panel-control.webp',
        ]
      },
      {
        id: 405,
        categoria: 'pesaje-dinamico',
        nombre: 'RIEL ELEVADO',
        descripcion: 'En Servibalanzas ofrecemos balanzas de riel elevado diseñadas especialmente para el pesaje preciso y seguro de ganado. Este sistema permite pesar al animal suspendido, garantizando lecturas estables y evitando errores ocasionados por movimientos  ',
        descripcion2: 'Con nuestras balanzas de riel elevado, los productores y plantas de faena obtienen control exacto del peso, mejoran la eficiencia operativa y aseguran el cumplimiento de estándares de calidad y comercialización. ',
        imagen: '/imagenes/productos/PesajeDinamico/riel1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Estructura robusta en acero para uso intensivo en entornos humedos ',
                'Sistema de pesaje en suspensión que asegura mediciones precisas. ',
                'Indicador de peso digital, con funciones de tara, acumulación y retención de lectura. ',
                'Capacidad de pesaje adaptada a diferentes tipos y tamaños de animales. ',
                'Superficie y componentes resistentes a la humedad y a la limpieza frecuente. ',
                'Posibilidad de integración con sistemas de registro y trazabilidad. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'riel-elevado',
            nombre: 'RIEL ELEVADO',

          },
        ],
        imagenes: [
          '/imagenes/productos/PesajeDinamico/riel1.webp',
          '/imagenes/productos/PesajeDinamico/riel2.webp',

        ]
      },
];
